import { Iframe } from '@/components/ui/Iframe';

interface PdfPreviewFrameProps {
  title: string;
  url: string;
  className?: string;
  hideToolbar?: boolean;
}

export function PdfPreviewFrame({
  title,
  url,
  className,
  hideToolbar = false,
}: PdfPreviewFrameProps) {
  return (
    <Iframe
      navigation="external"
      title={title}
      src={hideToolbar ? `${url}#toolbar=0` : url}
      className={className}
    />
  );
}
